import { ChangeEvent, useMemo, useState } from 'react';
import { LineType } from '../../types';

interface UseSearchesInterface {
  lines: LineType[];
}

export default function useSearches({ lines }: UseSearchesInterface) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredLines = useMemo(() => lines?.filter((line) => (
    line.lineCode.toLowerCase().includes(searchTerm.toLowerCase())
    || line.lineSign.toLowerCase().includes(searchTerm.toLowerCase())
    || line.workplaceDescription.toLowerCase().includes(searchTerm.toLowerCase())
  )), [lines, searchTerm]);

  function handleChangeSearchTerm(event: ChangeEvent<HTMLInputElement>) {
    setSearchTerm(event.target.value);
  }

  return {
    filteredLines,
    handleChangeSearchTerm,
    searchTerm,
  };
}
